<template>
  <div>
    <div class="title">

    </div>
    <div class="example-pane">
      <iframe id="example-page"
              :src="srcData"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      srcData: "",
    };
  },
  mounted() {
    this.srcData = "/api/index.html";
  },
};
</script>
<style lang="scss" scoped>
.title {
  height: 30px;
  line-height: 30px;
}
.example-pane {
  height: calc(100% - 50px);
  position: relative;
  padding: 10px;
  // background-color: #fff;
  #example-page {
    height: 100%;
    width: 100%;
    border: 0px;
  }
}
</style>